const debounceFunc = <F extends (...args: any[]) => unknown>(
  func: F,
  delay: number
) => {
  let debounceTimer: NodeJS.Timeout;

  return (...args: Parameters<F>) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export default debounceFunc;
